import '../libs/mmenu/jquery.mmenu.all';

export default function initializeMobileMenu() {
    let menu = $(".mobile-menu").mmenu({
            extensions: ["theme-dark"]
        }),
        icon = $(".hamburger"),
        api = menu.data("mmenu");

    icon.on("click", function () {
        api.open();
    });
}
